export default {

  methods: {
     // 返回当前节点的权限
     findNodePermission(node, id) {
      if (node.id === id) {
        return node.props.formPerms;
      }
      if (node.children) {
        if (Array.isArray(node.children)) {
          for (let child of node.children) {
            const result = this.findNodePermission(child, id);
            if (result && result.props) {
              return result.props.formPerms;
            }
          }
        } else {
          const result = this.findNodePermission(node.children, id);
          if (result && result.props) {
            return result.props.formPerms;
          }
        }
      }
      return null;
    },
    // 合并权限到数组表单中
    mergePermissions(a, b) {
      if (!Array.isArray(a) || !Array.isArray(b)) {
        return a;
      }
      const permMap = new Map(b.map(item => [item.id, item.perm]));
      return a.map(item => ({
        ...item,
        perm: permMap.get(item.id) || null
      }));
    },
  }
}
